import axios from "axios";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { z } from "zod";
import { removeNullFromObject } from "../../utils/RemoveNullFromObject.js";
import productUpdateSchema from '../../ValidationSchema/Product.schema.js'

const ProductUpdate = () => {
  const inputDiv = "mb-4 flex flex-col";
  const inputLabel = "mb-2 text-lg";
  const inputCss = "p-2 border-2 rounded-md";

  const navigate = useNavigate();
  const params = useParams();

  const id = params.id;

  const [product, setProduct] = useState();

  const [formData, setFormData] = useState({
    name: "",
    sellingPrice: 0,
    buyingPrice: 0,
    stock: 0,
    gst: 0,
    category: "",
    MRP: 0,
    materialCode: ""
  });



  useEffect(() => {
    getProduct();
  }, []);

  const getProduct = async () => {
    try {
      const response = await axios.get(`/product/${id}`);

      if (response.data.success) {
        setProduct(response.data.product);

        let p = response.data.product;
        setFormData(
          {
            name: p?.name,
            sellingPrice: p?.sellingPrice,
            buyingPrice: p?.buyingPrice,
            stock: p?.stock,
            gst: p?.gst,
            category: p?.category,
            discount: p?.discount,
            MRP: p?.MRP,
            materialCode: p?.materialCode
          }
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  const [categories, setCategories] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/category/");
        if (response.data.success) {
          setCategories(response.data.categories);
          toast.success(response.data.message);
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }

    })();
  }, []);



  //whenever user types in input fields, handles ==>
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    let data = formData;

    data = removeNullFromObject(formData);

    console.log({ data });


    try {
      data = productUpdateSchema.parse(data);
    } catch (error) {
      toast.error(error.errors[0].message);
      return;
    }

    try {
      const response = await axios.put(`/product/${id}`, data);

      if (response.data.success) {
        toast.success(response.data.message);
        navigate("/product/")
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <div className="container mx-auto flex justify-center items-center">
        <div
          className=" pt-5 pb-5 mt-5 mb-5 border-secondary  w-2/4 h-3/4 flex flex-col justify-center items-center"
          id="login-box"
        >
          <h1 className="text-center p-2 m-6 text-2xl font-semibold text-blue-700">
            Update Product
          </h1>

          <form onSubmit={handleSubmit} className="w-[60vw] sm:w-[100%] 2xl:w-[65%] flex flex-col space-y-5 border-2 border-blue-600 p-9 rounded-3xl">
            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="form1Example1">
                Product Name
              </label>
              <input
                type="text"
                id="form1Example1"
                className={inputCss}
                placeholder={product?.name}
                name="name"
                onChange={handleChange}
                value={formData.name}
              // required
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="mcode">
                Material Code
              </label>
              <input
                type="text"
                id="mcode"
                className={inputCss}
                placeholder="Material Code"
                name="materialCode"
                onChange={handleChange}
                value={formData.materialCode}
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="sellingPrice">
                Selling Price
              </label>
              <input
                type="text"
                id="sellingPrice"
                className={inputCss}
                placeholder={product?.sellingPrice}
                name="sellingPrice"
                onChange={handleChange}
                value={formData.sellingPrice}
              //   required
              />
            </div>
            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="buyingPrice">
                Buying Price
              </label>
              <input
                type="text"
                id="buyingPrice"
                className={inputCss}
                placeholder={product?.buyingPrice}
                name="buyingPrice"
                onChange={handleChange}
                value={formData.buyingPrice}
              //   required
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="stock">
                Stock
              </label>
              <input
                type="text"
                id="stock"
                className={inputCss}
                placeholder={product?.stock}
                name="stock"
                onChange={handleChange}
                value={formData.stock}
              //   required
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="gst">
                GST
              </label>
              <input
                type="text"
                id="gst"
                className={inputCss}
                placeholder={product?.gst}
                name="gst"
                onChange={handleChange}
                value={formData.gst}
              //   required
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="discount">
                Discount
              </label>
              <input
                type="text"
                id="discount"
                className={inputCss}
                placeholder={product?.discount}
                name="discount"
                onChange={handleChange}
                value={formData?.discount}
              //   required
              />
            </div>

            <div>
              <label htmlFor="category">Category</label>
              <select id="category" name="category" onChange={handleChange} value={formData.category}
                className="select select-bordered w-full">
                <option selected>Select Category</option>
                {
                  categories.map((c) => {
                    return (
                      <>
                        <option value={c._id}>{c.title}</option>
                      </>
                    )
                  })
                }
              </select>
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="MRP">
                MRP
              </label>
              <input
                type="text"
                id="MRP"
                className={inputCss}
                placeholder="MRP Price"
                name="MRP"
                onChange={handleChange}
                value={formData?.MRP}
              />
            </div>


            <div className="text-center">
              <button
                type="submit"
                className="bg-blue-700 text-white w-full py-2 rounded-md bottom-2 "
              >
                Update Product
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ProductUpdate;
